import { createReducer, requestStatus } from '../../lib/Utils'
import {
  GET_FACEBOOK_PAGES,
  GET_FACEBOOK_PAGES_FULFILLED,
  GET_FACEBOOK_PAGES_REJECTED,
} from './actions'

const initialState = {
  byRetailerAccountId: {},
  facebookPagesStatus: null,
  facebookPagesErrors: null,
}

export const GENERIC_ERROR_MSG = 'Request failed'

export default createReducer(initialState, {
  [GET_FACEBOOK_PAGES]: (state) => {
    return {
      ...state,
      facebookPagesStatus: requestStatus.pending,
      facebookPagesErrors: null,
    }
  },
  [GET_FACEBOOK_PAGES_FULFILLED]: (state, action) => {
    const newState = {
      ...state,
      facebookPagesStatus: requestStatus.complete,
      facebookPagesErrors: null,
      byRetailerAccountId: {
        ...state.byRetailerAccountId,
        [action.payload.retailerAccountId]: action.payload.facebookPages,
      },
    }
    return newState
  },
  [GET_FACEBOOK_PAGES_REJECTED]: (state, action) => {
    let facebookPagesErrors
    if (action.payload && action.payload.errors) {
      facebookPagesErrors = action.payload.errors
    } else {
      facebookPagesErrors = [GENERIC_ERROR_MSG]
    }
    const newState = {
      ...state,
      facebookPagesStatus: requestStatus.rejected,
      facebookPagesErrors,
      byRetailerAccountId: {
        ...state.byRetailerAccountId,
        [action.payload.retailerAccountId]: [],
      },
    }
    return newState
  },
})
